import { createUrlResolver, siteConfig, type Language, type SiteName } from "@seek/melways-sites";

export const hasMultiLanguage = (site: SiteName) => {
  const languages = siteConfig[site].languages;
  return languages.length > 1
}

export const getLanguageSwitcher = ({site, language, path}: {site: SiteName, language: Language, path: string}) => {
  if (!hasMultiLanguage(site)) {
    return undefined;
  }

  const languages = siteConfig[site].languages;
  const urlResolver = createUrlResolver({ site, language });

  return Object.fromEntries(
    languages.map(lang => [
      lang,
      { url: urlResolver({ language: lang as Language, path }) }
    ])
  );
};
